export var linear = function (t) { return +t; };
